import { Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ComponentService } from '../../../services/component.service';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { tap, filter, debounceTime } from 'rxjs/operators';
import { FontsService, Font } from '../../../services/fonts.service';
import { AuthService } from '../../../services/auth.service';

@Component({
	selector: 'app-news-ticker',
	templateUrl: './news-ticker.component.html',
	styleUrls: ['./news-ticker.component.scss']
})
export class NewsTickerComponent implements OnInit, OnDestroy {
	@Input() componentData: any;
	@Input() formHeight: string;
	@Input() pageType: string;
	@Input() componentID: number;
	@Input() urlGlobalRegExp: any;
	@ViewChild('newsTickerForm', { static: true }) newsTickerForm: NgForm;
	@ViewChild('nameField', { static: true }) nameField;
	newsTickerFormSubscription: Subscription;
	font;
	secondsForFrame;
	fonts: Array<Font>;
	isAdmin;

	constructor(private comService: ComponentService, private fontsService: FontsService, private auth: AuthService) {}

	ngOnInit() {
		this.isAdmin = this.auth.isAdmin();
		if (this.componentData.config.version == 1 && this.componentData.config.responsive == 0) {
			this.componentData.config.responsive = false;
		}

		this.newsTickerFormSubscription = this.newsTickerForm.valueChanges
			.pipe(
				tap(() =>
					this.comService.updateDisabledSave(
						(this.newsTickerForm.dirty && this.newsTickerForm.invalid) || this.nameField.editComponentName
					)
				),
				filter((form) => this.newsTickerForm.dirty && this.newsTickerForm.valid),
				debounceTime(2000)
			)
			.subscribe();

		this.fonts = this.fontsService.getFonts();

		this.font =
			this.fontsService.getFontsArray().indexOf(this.componentData.config.text.font) === -1
				? 'Custom Font'
				: this.componentData.config.text.font;

		this.secondsForFrame = this.componentData.config.total_duration / this.componentData.config.count;
	}

	ngOnDestroy() {
		this.newsTickerFormSubscription.unsubscribe();
	}

	brodcastToPreview() {
		this.comService.updateComponentData(this.componentData);
		this.comService.updatePreviewData();
	}
}
